/* tslint:disable */
/* eslint-disable */
export enum WorkEventInvitationDeclinedStatusEnum {
  Entschuldigt = 'ENTSCHULDIGT',
  Unentschuldigt = 'UNENTSCHULDIGT'
}
